<template>
    <div>
        <tab name="2"></tab>
        <div v-loading="dataLoading">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="name" label="群组名称：">
                            {{ formData.name }}
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="disbandmentTimeType" label="解散时间:">
                            <el-select v-model="formData.disbandmentTimeType">
                                <el-option label="演出结束后48小时自动解散" :value="0"></el-option>
                                <el-option label="演出结束后7天自动解散" :value="1"></el-option>
                                <el-option label="演出结束后30天自动解散" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="owner" label="指定群主：">
                            <el-select v-model="formData.owner" filterable remote placeholder="请选择群主"
                                :remote-method="searchMainUser" :loading="userLoading" value-key="id">
                                <el-option v-for="item in mainUserList" :key="item.id"
                                    :label="`${item.name}(${item.id})`" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="adminList" label="指定群管理:">
                            <span slot="label">指定群管理：<el-checkbox v-model="formData.isAddHost" :true-label="1" :false-label="0">自动将演出主办设置为群管理</el-checkbox></span>
                            <el-select v-model="formData.adminList" multiple filterable remote placeholder="请选择群组管理"
                                :remote-method="searchAdminUser" :loading="userLoading" value-key="id">
                                <el-option v-for="item in adminUserList" :key="item.id"
                                    :label="`${item.name}(${item.id})`" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="MT20">
                <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认更新</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import Tab from './components/tab'
import { fetchUser } from '@/assets/js/commonApi';
const defaultData = {
    id: "",
    name: "演出短标题",
    isAddHost: 0,
    adminList: [],
    owner: null,
    disbandmentTimeType: 0
}
export default {
    components: { Tab },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData: {
                ...defaultData
            },

            rules: {
                // name:[{ required: true, message: "请填写名称" }],
                owner: [{ required: true, message: "请选择群主" }]
            },

            userLoading: false,
            mainUserList: [],
            adminUserList: [],
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.dataLoading = true;
            this.$request({
                url: '/group/configInfo',
                params: {},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.formData = {
                            ...this.formData,
                            ...result
                        }

                        this.mainUserList.push(result.owner);
                        this.adminUserList = result.adminList || [];

                    } else {
                        this.$message.error(msg || "请求失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("请求失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/group/configUpdate',
                        data: { ...this.formData },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                return this.$message.success("操作成功");
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        async searchMainUser(query) {
            this.searchUser(query, 'mainUserList');
        },
        async searchAdminUser(query) {
            this.searchUser(query, 'adminUserList');
        },
        // 查找用户
        async searchUser(query, type) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue: query,
                    userType: 0
                }).finally(() => {
                    this.userLoading = false;
                });

                const { state, result } = res.data;

                if (state == 1 && result) {
                    if (type == 'mainUserList') {
                        this.mainUserList = result
                    }
                    if (type == 'adminUserList') {
                        this.adminUserList = result
                    }
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>